import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import FAQ from './pages/FAQ';
import Courses from './pages/Courses';
import Products from './pages/Products';
import Apply from './pages/Apply'; // <--- Apply Component Import
import Login from './pages/Login';
import Signup from './pages/Signup';  
import Profile from './pages/Profile';
import ForgotPassword from './pages/ForgotPassword';
import MutualFunds from './pages/Products/MutualFunds';
import SIF from './pages/Products/SIF';
import PMS from './pages/Products/PMS';
import BondsFDs from './pages/Products/BondsFDs';
import AIF from './pages/Products/AIF';
import Offshore from './pages/Products/Offshore';
import PreIPO from './pages/Products/PreIPO';


export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col text-gray-900 bg-[#FAF8F5] selection:bg-[#10B981] selection:text-white">
        <Navbar />
        
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/about" element={<About />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/products" element={<Products />} />
            <Route path="/apply" element={<Apply />} /> {/* <--- Route Mapped to Apply Component */}
            
            {/* Products Sub-routes Placeholder */}
            <Route path="/products/mutual-funds" element={<MutualFunds />} />
            <Route path="/products/sif" element={<SIF />} />
            <Route path="/products/pms" element={<PMS />} />
            <Route path="/products/bonds-fds" element={<BondsFDs />} />
            <Route path="/products/bonds" element={<BondsFDs />} />
            <Route path="/products/aif" element={<AIF />} />
            <Route path="/products/offshore" element={<Offshore />} />
            <Route path="/products/pre-ipo" element={<PreIPO />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}